// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1NT7o","title":"BackImages_title__1cY58","images":"BackImages_images__31-78"};